import { action, payload } from 'ts-action'
import { getActionType } from './constants'

export const setUserAccessToken = action(
    getActionType('Set User Access Token'),
    payload<{ userAccessToken: string }>()
)

export const clearUserAccessToken = action(getActionType('Clear User Access Token'))

export const setUserAccount = action(getActionType('Set User Account'), payload<{ userAccount: string }>())

export const clearUserAccount = action(getActionType('Clear User Account'))
